<div class="teaser-item card" *ngIf="data && portalId !== 'de-ext'">
    <a [routerLink]="data.link | localize" [queryParams]="{ cat: data.category | localize }" (click)="goToCoursesPage(data.category)">
        <div class="cardcontent">
            <div class="cardheader">
                <div class="media" *ngIf="data.img">
                    <figure>
                        <da-progressive-image
                            [options]="{
                                alt: data.title,
                                aspectRatios: [
                                    {
                                        breakpoint: 360,
                                        width: 480,
                                        height: 320,
                                        akamaiImage: data.img
                                    },
                                    {
                                        breakpoint: 480,
                                        width: 780,
                                        height: 520,
                                        akamaiImage: data.img
                                    },
                                    {
                                        breakpoint: 768,
                                        width: 480,
                                        height: 320,
                                        akamaiImage: data.img
                                    },
                                    {
                                        breakpoint: 960,
                                        width: 380,
                                        height: 253,
                                        akamaiImage: data.img
                                    },
                                    {
                                        breakpoint: 1120,
                                        width: 480,
                                        height: 320,
                                        akamaiImage: data.img
                                    }
                                ]
                            }"
                        ></da-progressive-image>
                    </figure>
                </div>
                <div class="copy large">
                    <a alt="" [routerLink]="data.link | localize" (click)="goToCoursesPage(data.category)">{{ data.title }}</a>
                    <p>{{ data.desc }}</p>
                </div>
            </div>
            <div class="cardfooter"></div>
        </div>
    </a>
</div>
<div class="teaser-item card" *ngIf="data && portalId === 'de-ext'">
    <a href="{{data.link}}">
        <div class="cardcontent">
            <div class="cardheader">
                <div class="media" *ngIf="data.img">
                    <figure>
                        <da-progressive-image
                            [options]="{
                                alt: data.title,
                                aspectRatios: [
                                    {
                                        breakpoint: 360,
                                        width: 480,
                                        height: 320,
                                        akamaiImage: data.img
                                    },
                                    {
                                        breakpoint: 480,
                                        width: 780,
                                        height: 520,
                                        akamaiImage: data.img
                                    },
                                    {
                                        breakpoint: 768,
                                        width: 480,
                                        height: 320,
                                        akamaiImage: data.img
                                    },
                                    {
                                        breakpoint: 960,
                                        width: 380,
                                        height: 253,
                                        akamaiImage: data.img
                                    },
                                    {
                                        breakpoint: 1120,
                                        width: 480,
                                        height: 320,
                                        akamaiImage: data.img
                                    }
                                ]
                            }"
                        ></da-progressive-image>
                    </figure>
                </div>
                <div class="copy large">
                    <a href="{{data.link}}">{{ data.title }}</a>
                    <p>{{ data.desc }}</p>
                </div>
            </div>
            <div class="cardfooter"></div>
        </div>
    </a>
</div>
